import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Flex, FormControl, FormLabel, Heading, Input, Text, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin, sendOtp } from "../../../redux/actions/Admin.action";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import illustration from "assets/img/banner.png";
import logo from "assets/img/Sculpt-logo.png";

function SignIn() {
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const adminData = useSelector((state) => state.admin)

  const token = adminData?.SendOtp?.data?.user?.token;
  const type = adminData?.SendOtp?.data?.user?.type;

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
    otp: Yup.string().when('otpSent', {
      is: true,
      then: Yup.string().required('OTP is required'),
    }),
  });

  useEffect(() => {
    if (adminData?.LoginAdmin?.data?.status === 200) {
      setOtpSent(true);
    }
  }, [adminData]);

  const handleSubmit = (values) => {
    setLoader(true);

    if (!otpSent) {
      const payload = { email: values.email };
      dispatch(adminLogin(payload))
        .then(() => {
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    } else {
      const payload = { email: values.email, otp: values.otp };
      dispatch(sendOtp(payload))
        .then(() => {
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    }
  };

  useEffect(() => {
    if (adminData?.SendOtp?.data?.status === 200 && token) {
      setLoader(false);
      navigate('/master/MasterDashboard');
      window.location.reload();
    } else if (adminData?.SendOtp?.status === 404) {
      toast.error("Admin is not authenticated!");
      setLoader(false);
    } else if (adminData?.SendOtp?.status === 200 && !token) {
      toast.error("Admin is not authenticated!");
      setLoader(false);
    } else if (adminData?.SendOtp?.status === 401) {
      toast.error("OTP Invalid");
      setLoader(false);
    }

  }, [adminData, navigate, token]);

  return (
    <>
      {loader && (
        <div className="loaderAdd">
          <div className="loader_line"><img src={logo} className="w-[130px]" /></div>
        </div>
      )}
      <div className={`row justify-content-center items-center`}>
        <div className="col-6">
          <Flex
            maxW={{ base: "100%", md: "max-content" }}
            w='100%'
            mx='auto'
            h='100%'
            alignItems='start'
            justifyContent='center'
            mb={{ base: "30px", md: "60px" }}
            px={{ base: "25px", md: "0px" }}
            flexDirection='column'>
            <Box me='auto'>
              <div>
                <img src={logo} className="w-[170px] mb-5" />
              </div>
              <Heading color={textColor} fontSize='36px' mb='10px'>
                Sign In
              </Heading>
              <Text
                className="mb-5"
                ms='4px'
                color={textColorSecondary}
                fontWeight='400'
                fontSize='md'>
                Enter your email {otpSent ? "and OTP to sign in!" : "to receive OTP!"}
              </Text>
            </Box>
            <Flex
              zIndex='2'
              direction='column'
              w={{ base: "100%", md: "420px" }}
              maxW='100%'
              background='transparent'
              borderRadius='15px'
              mx={{ base: "auto", lg: "unset" }}
              me='auto'
              mb={{ base: "20px", md: "auto" }}>

              <Formik
                initialValues={{ email: '', otp: '' }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  handleSubmit(values);
                }}
              >
                {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <FormControl>
                      <FormLabel
                        display='flex'
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        mb='8px'>
                        Email<Text style={{ color: '#F5EAD5' }}>*</Text>
                      </FormLabel>
                      <Field
                        as={Input}
                        name="email"
                        variant='auth'
                        fontSize='sm'
                        ms={{ base: "0px", md: "0px" }}
                        type='email'
                        placeholder='Enter Email Id'
                        fontWeight='500'
                        size='lg'
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.email && <ErrorMessage name="email" component="div" style={{ color: 'red', marginTop: "5px" }} />}

                      {/* <FormLabel
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        display='flex'
                        alignItems={'center'}
                        mt='24px'
                      >
                        Password
                      </FormLabel>
                      <InputGroup size='md' className="relative">
                        <Field
                          as={Input}
                          name="password"
                          fontSize='sm'
                          placeholder='Enter Password'
                          size='lg'
                          type={show ? "text" : "password"}
                          variant='auth'
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <div className="absolute top-3 right-3" onClick={handleClick}>
                          {show ? <ViewIcon /> : <ViewOffIcon />} {/* Toggle between ViewIcon and ViewOffIcon
                        </div>
                      </InputGroup>
                      {touched.password && <ErrorMessage name="password" component="div" style={{ color: 'red', marginTop: "5px" }} />} */}

                      {otpSent && (
                        <>
                          <FormLabel fontSize='sm' fontWeight='500' color={textColor} mt='24px'>
                            OTP
                          </FormLabel>
                          <Field
                            as={Input}
                            name="otp"
                            variant='auth'
                            fontSize='sm'
                            type="text"
                            placeholder='Enter OTP'
                            size='lg'
                            value={values.otp}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {touched.otp && <ErrorMessage name="otp" component="div" style={{ color: 'red', marginTop: "5px" }} />}
                        </>
                      )}

                      <Button
                        fontSize='md'
                        variant='brand'
                        fontWeight='500'
                        w='100%'
                        h='50'
                        mb='24px'
                        mt='24px'
                        className="!bg-theme-dark"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {otpSent ? "Sign In" : "Send OTP"}
                      </Button>
                    </FormControl>
                  </Form>
                )}
              </Formik>
            </Flex>
          </Flex>
        </div>
        <div className="col-6">
          <div style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)),url(${illustration})`, minHeight: '100vh' }} className="d-flex bg-cover bg-center justify-content-center align-items-center w-100">
          </div>
        </div>
      </div>
    </>
  );
}

export default SignIn;